'use es6';

import Actions from 'AdsUI/lib/Actions';
import AdWordsTrackingTemplateRecord from 'AdsUI/records/rmf/AdWordsTrackingTemplateRecord';
const initialState = new AdWordsTrackingTemplateRecord();
export default ((state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.ADWORDS_TRACKING_TEMPLATE_FETCH_SUCCEEDED:
    case Actions.ADWORDS_TRACKING_TEMPLATE_UPDATE_SUCCEEDED:
      if (payload) {
        state = state.merge({
          adWordsTrackingTemplate: payload.trackingUrlTemplate
        });
      }

      break;

    default:
      break;
  }

  return state;
});